'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UISpinner = require('UIComponents/loading/UISpinner');

var _UISpinner2 = _interopRequireDefault(_UISpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOADING_INDICATOR_DELAY_MS = 300;

var VisitorWidgetFileAttachmentPlaceholder = function (_React$Component) {
  _inherits(VisitorWidgetFileAttachmentPlaceholder, _React$Component);

  function VisitorWidgetFileAttachmentPlaceholder(props) {
    _classCallCheck(this, VisitorWidgetFileAttachmentPlaceholder);

    var _this = _possibleConstructorReturn(this, (VisitorWidgetFileAttachmentPlaceholder.__proto__ || Object.getPrototypeOf(VisitorWidgetFileAttachmentPlaceholder)).call(this, props));

    _this.state = {
      showingLoadingIndicator: false
    };

    _this.loadingIndicatorTimeoutId = 0;
    return _this;
  }

  _createClass(VisitorWidgetFileAttachmentPlaceholder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showLoadingIndicatorOnTimeout();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearLoadingIndicatorTimeout();
    }
  }, {
    key: 'showLoadingIndicatorOnTimeout',
    value: function showLoadingIndicatorOnTimeout() {
      var _this2 = this;

      this.loadingIndicatorTimeoutId = setTimeout(function () {
        _this2.setState({
          showingLoadingIndicator: true
        });
      }, LOADING_INDICATOR_DELAY_MS);
    }
  }, {
    key: 'clearLoadingIndicatorTimeout',
    value: function clearLoadingIndicatorTimeout() {
      clearTimeout(this.loadingIndicatorTimeoutId);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.showingLoadingIndicator ? _react2.default.createElement(_UISpinner2.default, null) : null;
    }
  }]);

  return VisitorWidgetFileAttachmentPlaceholder;
}(_react2.default.Component);

exports.default = VisitorWidgetFileAttachmentPlaceholder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/attachments/VisitorWidgetFileAttachmentPlaceholder.js
// module id = 1140
// module chunks = 2 3